// extracted by css-extract-rspack-plugin
export default {"chip":"_c6b4cd5c","chipPlaceholder":"_95f6c29f","active":"_cd8455a2"};